import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import CurrentUserURI from "./CurrentUserURIBuilder";

export interface IHasPermissionOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
}

export const createRequest = (funcName: string, customerId: number, opts: IHasPermissionOpts): Request => {
  const { apiUrl, apikey, ...restOpts } = opts;
  const url = new CurrentUserURI().setApiUrl(apiUrl).setSegment(["permission", funcName, customerId.toString()]);

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
  };

  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(url), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function hasPermission(
  funcName: string,
  customerId: number,
  opts: IHasPermissionOpts,
): Promise<JsonQuery<IResultstash<string[]>>> {
  return await fetchJsonQuery<IResultstash<string[]>>(createRequest(funcName, customerId, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}
export default hasPermission;
